import api from "../../utils/apiUser";

export const getPedidoDocs = async (pedidoId) => {
  const res = await api.get(`/api/admin/pedidos_docs/${pedidoId}`);
  return Array.isArray(res.data) ? res.data : [];
};

export const uploadPedidoDocs = async (pedidoId, files = []) => {
  const form = new FormData();
  (files || []).forEach((f) => form.append("files", f));

  const res = await api.post(`/api/admin/pedidos_docs/${pedidoId}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return Array.isArray(res.data) ? res.data : [];
};

export const deletePedidoDoc = async (pedidoId, docId) => {
  const res = await api.delete(`/api/admin/pedidos_docs/${pedidoId}/${docId}`);
  return Array.isArray(res.data) ? res.data : [];
};
